import React, { useEffect } from "react";
import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "@reduxjs/toolkit";
// enums
import { EView } from "cms/enums/EView";
import { EViewType } from "cms/enums/EViewType";
import { EContentType } from "cms/enums/EContentType";
// actions
import { TMainPageLayout } from "../type";
// interfaces
import IClientLanguage from "core/interfaces/IClientLanguage";
import IClientSiteSettingDetail from "cms/interfaces/IClientSiteSettingDetail";
import LanguageVersionSelector from "cms/utilities/LanguageVersionSelector";
import ILanguageVersionList from "cms/interfaces/ILanguageVersionList";
import { Link } from "react-router-dom";
import SanitizeHTMLString from "cms/utilities/SanitizeHTMLString";
import RMDRImage from "components/RMDRImage";
import { EResourceType } from "cms/enums/EResourceType";
import RMDRLink from "components/RMDRLink";
import useProgressiveImage from "core/hooks/useProgressiveImage";


function mapStateToProps ( state: any ) {
    console.log("MNPG003.mapStateToProps: ", state);

    const webApplicationLanguage:IClientLanguage   = state.CoreStore.language?.payload;
    const webApplicationLanguageCode:string        = webApplicationLanguage.code;
    const webApplicationLanguageISOCode:string     = state.CoreStore.languageCode?.payload;

    const siteSettingDetailPayload:IClientSiteSettingDetail     = state.SiteSettingStore.details?.payload;

    return {

        webApplicationLanguage,
        webApplicationLanguageCode,
        webApplicationLanguageISOCode,

        siteSettingDetailPayload

    }
}

function mapDispatchToProps ( dispatch: Dispatch ) {
    console.log("MNPG003.mapDispatchToProps");

    return {

    }
}

const connector = connect(mapStateToProps, mapDispatchToProps);


/* types */
type PropsFromRedux = ConnectedProps<typeof connector>


/* component */
function MMNPG003Loader () {

    return (
        <></>
    )

}

function MNPG003 ( props:TMainPageLayout<PropsFromRedux> ) {
    console.log("MNPG003.rendered", props)

    const parentLanguageVersion = LanguageVersionSelector<ILanguageVersionList|null>({
        languageVersions: props.parentPayload?.languageVersions,
        filters: [
            { view: EView.OUTTER, viewType: EViewType.NAME_DESCRIPTION, contentType: EContentType.MAIN_PAGE_ITEM },
            { view: EView.OUTTER, viewType: EViewType.NAME_DESCRIPTION, contentType: EContentType.DEFAULT }
        ],
        type: "find"
    });

    const loaded = useProgressiveImage({ src:"/assets/images/shapes/services-six-bg-shape.webp" });

    return (
        <section className="services-six">
            <div className="services-six__bg-box">
                <div className="services-six__bg"
                    style={loaded?{backgroundImage: `url('${loaded}')`, backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "cover"}:undefined}
                />
            </div>
            <div className="container">
                <div className="services-six__top">
                    <div className="section-title text-left">
                        <div className="section-title__tagline-box">
                            <span className="section-title__tagline">{parentLanguageVersion?.name}</span>
                        </div>
                        <h2 className="section-title__title ck-content" dangerouslySetInnerHTML={{ __html: SanitizeHTMLString(parentLanguageVersion?.value)}} />
                    </div>
                </div>
                <div className="services-six__bottom">
                    <div className="row">
                        {
                            props.childsPayload?.map((item) => {

                                const childLanguageVersion = LanguageVersionSelector<ILanguageVersionList|null>({
                                    languageVersions: item?.languageVersions,
                                    filters: [
                                        { view: EView.OUTTER, viewType: EViewType.NAME_DESCRIPTION, contentType: EContentType.DEFAULT }
                                    ],
                                    type: "find"
                                });

                                const redirectUrl = LanguageVersionSelector<ILanguageVersionList|null>({
                                    languageVersions: item?.languageVersions,
                                    filters: [
                                        { view: EView.META_DATA, viewType: EViewType.TEXT, contentType: EContentType.DEFAULT, name: "redirectUrl" }
                                    ],
                                    type: "find"
                                });

                                return (
                                    <div key={childLanguageVersion?.id} className="col-xl-4 col-lg-4 wow fadeInUp" data-wow-delay="100ms">
                                        <div className="services-six__single">
                                            <div className="services-six__img-box">
                                                <div className="services-six__img">
                                                    <RMDRImage
                                                        resources={item.resources}
                                                        resourceType={EResourceType.OUTER_IMAGE}
                                                        alt={childLanguageVersion?.name}
                                                        title={childLanguageVersion?.name}
                                                    />
                                                </div>
                                            </div>
                                            <div className="services-six__content">
                                                <h3 className="services-six__title">
                                                    <RMDRLink
                                                        title={childLanguageVersion?.name}
                                                        text={childLanguageVersion?.name}
                                                        hasNavigationDestination={item?.hasDestinationNavigation}
                                                        navigationURL={childLanguageVersion?.contentRouteNavigationURL}
                                                        redirectType={item?.redirectType}
                                                        redirectUrl={redirectUrl?.value}
                                                        isShowAlways={true}
                                                    />
                                                </h3>
                                                <p className="services-six__text ck-content" dangerouslySetInnerHTML={{ __html: SanitizeHTMLString(childLanguageVersion?.value)}} />
                                                {/* <div className="services-six__read-more">
                                                    <Link to="service-details">Read more<span
                                                            className="icon-dabble-arrow-right"></span></Link>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                )

                            })
                        }
                    </div>
                </div>
            </div>
        </section>
    )

}

const Component = React.memo(MNPG003, ( prevProps: TMainPageLayout<PropsFromRedux>, nextProps: TMainPageLayout<PropsFromRedux> ) => {
    return true;
});

export default connector(Component);
